import { useLocalStorage } from '../../hooks/useLocalStorage';
import { LocalStorageKeys } from '../../services/localStorage';

const IMMEDIATE_ATTEMPTS = 2;
const FIRST_COOLDOWN = 30 * 1000;
const MAX_COOLDOWN = 60 * 60 * 1000;

const cooldownAfter = (attempts: number) =>
  attempts < IMMEDIATE_ATTEMPTS
    ? 0
    : Math.min(FIRST_COOLDOWN * 2 ** (attempts - IMMEDIATE_ATTEMPTS), MAX_COOLDOWN);

export const useOneClickLoginAttempts = () => {
  const [loginAttempts, setLoginAttempts] = useLocalStorage(
    LocalStorageKeys.ONE_CLICK_LOGIN_EMAIL,
    { email: '', lastAttemptAt: 0, attempts: 0 },
  );

  const attemptsWithin = (email: string, now: number) => {
    const startsNewWindow =
      email !== loginAttempts.email ||
      !loginAttempts.lastAttemptAt ||
      now - loginAttempts.lastAttemptAt >= MAX_COOLDOWN;

    return startsNewWindow ? 0 : loginAttempts.attempts;
  };

  const cooldownRemaining = (email: string) => {
    const now = Date.now();
    const attempts = attemptsWithin(email, now);

    if (attempts === 0) {
      return 0;
    }

    return Math.max(loginAttempts.lastAttemptAt + cooldownAfter(attempts) - now, 0);
  };

  const recordAttempt = (email: string) => {
    const now = Date.now();

    setLoginAttempts({
      email,
      lastAttemptAt: now,
      attempts: attemptsWithin(email, now) + 1,
    });
  };

  return { cooldownRemaining, recordAttempt };
};
